import React, { useState } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { Link, useHistory } from 'react-router-dom';

import * as crossService from '../services/cross';

type RandomizeType = {
  isRandomizing: boolean;
};

const spin = keyframes`
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(1080deg);
  }
`;
const Container = styled.li`
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
  position: relative;
  z-index: 0;
  height: 100%
  padding: 20px;

  &:before {
    content: '';
    transition: transform .60s ease-out;
    position: absolute;
    top: -35px;
    right: -35px;
    background-color: #57687F;
    border-radius: 40%;
    transform: scale(1);
    transform-origin: 50% 50%;
    width: 50px;
    height: 50px;
    z-index: -1;
  }

  &:hover {
    &:before {
      transform: scale(35);
    }
  }
`;
const Section = styled.section`
  height: 100%;
`;
const LinkItem = styled(Link)`
  color: #FFFFFF;
  text-decoration: none;
  display: block;
  padding: 20px;
  height: calc(100% - 40px);
`;
const Headline = styled.h1`
  font-weight: 700;
  font-size: 22px;
  margin: 0 0 10px 0;
`;
const ExerciseList = styled.ol`
  list-style-type: circle;
  padding: 0;
  margin: 0;
`;
const ExerciseListItem = styled.li`
  margin-left: 1rem;
`;
const Go = styled.div`
  background-color: #57687F;
  border-radius: 40%;
  position: absolute;
  width: 50px;
  height: 50px;
  top: -25px;
  right: -25px;
`;
const Plus = styled.div`
  position: absolute;
  bottom: 2px;
  left: 8px;
  font-size: 21px;
`;
const animation = css`
  animation: ${spin} 0.9s ease-in-out both;
`
const Random = styled.div<RandomizeType>`
  font-size: 75px;
  font-weight: 700;
  text-align: center;
  ${props => props.isRandomizing ? animation : ''};
`;

interface IOwnProps {
  programme?: crossService.Programme;
  programmes?: crossService.Programme[];
}

type Props = IOwnProps;

function WorkoutListItem(props: Props) {
  const history = useHistory();
  const [randomizing, setRandomizing] = useState(false);

  const findRandom = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    setRandomizing(true);

    setTimeout(() => {
      const programme = props.programmes![Math.floor(Math.random()*props.programmes!.length)];

      history.push(`/${programme.id}`);
    }, 1000);
  };

  if ((props.programme && props.programmes) || (!props.programme && !props.programmes)) return null;

  return (
    <Container>
      <Section>
        {!props.programme &&
          <LinkItem to="#" onClick={(e) => findRandom(e)}>
            <Headline>Random</Headline>
            <Random isRandomizing={randomizing}>?</Random>
            <Go>
              <Plus>+</Plus>
            </Go>
          </LinkItem>
        }
        {props.programme &&
          <LinkItem to={`/${props.programme.id}`}>
            <Headline>{props.programme.name}</Headline>
            <ExerciseList>
              {props.programme.sets && props.programme.sets.map((set) => {
                return <ExerciseListItem key={set.id}>{set.name}</ExerciseListItem>
              })}
            </ExerciseList>
            <Go>
              <Plus>+</Plus>
            </Go>
          </LinkItem>
        }
      </Section>
    </Container>
  );
}

export default WorkoutListItem;